export default __webpack_public_path__ + "static/media/terrabound26.5db57382.jpeg";